import { createSlice } from "@reduxjs/toolkit";

export const intialTemplateLocalState = {
  document_name: "",
  document_type: "",
  html_content: "",
  placeholders: [],
  sample_json_data: {},
  is_current: false,
};

const initialState = {
  htmlTemplates: [],
  pagination: {},
  newTemplateLocal: intialTemplateLocalState,
  isHtmlTemplateResponseSuccess: false,
  isHtmlTemplateResponseError: false,
  htmlTemplateDetails: {},
};

export const htmlTemplateSlice = createSlice({
  name: "htmlTemplate",
  initialState,
  reducers: {
    getHtmlTemplateListAction: (state) => {},
    setHtmlTemplateListAction: (state, { payload }) => {
      const { pagination = { currentPage: 1 }, list = [] } = payload;
      state.htmlTemplates = payload?.list;
      state.pagination = pagination;
    },

    addHtmlTemplateAction: (state, { payload }) => {},
    setAddHtmlTemplateAction: (state, { payload }) => {
      state.isHtmlTemplateResponseSuccess = payload;
    },

    updateHtmlTemplateAction: (state, { payload }) => {},
    setUpdateHtmlTemplateAction: (state, { payload }) => {
      state.isHtmlTemplateResponseSuccess = payload;
    },

    getSingleHtmlTemplateDetailsAction: (state, { payload }) => {},
    setSingleHtmlTemplateDetailsAction: (state, { payload }) => {
      state.htmlTemplateDetails = payload;
    },

    deleteHtmlTemplateAction: (state, { payload }) => {},
    setDeleteHtmlTemplateAction: (state, { payload }) => {
      state.isHtmlTemplateResponseSuccess = payload;
    },

    setNewTemplateLocal: (state, action) => {
      state.newTemplateLocal = action.payload;
    },
    resetNewTemplateLocal: (state) => {
      state.newTemplateLocal = intialTemplateLocalState;
    },
  },
});

const {
  getHtmlTemplateListAction,
  setHtmlTemplateListAction,
  addHtmlTemplateAction,
  setAddHtmlTemplateAction,
  updateHtmlTemplateAction,
  setUpdateHtmlTemplateAction,
  getSingleHtmlTemplateDetailsAction,
  setSingleHtmlTemplateDetailsAction,
  deleteHtmlTemplateAction,
  setDeleteHtmlTemplateAction,
  setNewTemplateLocal,
  resetNewTemplateLocal,
} = htmlTemplateSlice.actions;

export {
  getHtmlTemplateListAction,
  setHtmlTemplateListAction,
  addHtmlTemplateAction,
  setAddHtmlTemplateAction,
  updateHtmlTemplateAction,
  setUpdateHtmlTemplateAction,
  getSingleHtmlTemplateDetailsAction,
  setSingleHtmlTemplateDetailsAction,
  deleteHtmlTemplateAction,
  setDeleteHtmlTemplateAction,
  setNewTemplateLocal,
  resetNewTemplateLocal,
};

export default htmlTemplateSlice.reducer;
